import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';

import HtmlText from 'html-text/HtmlText';
import { Button, Modal as CrateModal, Spinner } from '@tcc/crate';

let MessageModal = ({
  actions=[],
  blocking=false,
  bodyHtmlMessageKey,
  bodyHtmlMessageParams,
  bodyText,
  className,
  footerText=null,
  name,
  size='M',
  title
}) => {
  const classString = classNames({
    'vra-modal__wrapper': true,
    'vra-modal__wrapper--no-title': !title,
    [`vra-modal--${name}__wrapper`]: !!name,
    [`${className}`]: !!className
  });

  const header = (title)
    ? (
      <header className='vra-modal-header'>
        {title}
      </header>
    ) : null;

  let body;
  if (bodyHtmlMessageKey || bodyText) {
    const spinner = blocking ? (
      <div className='vra-modal-body__spinner-container'>
        <Spinner size={24} />
      </div>
    ) : null;
    const bodyInner = bodyHtmlMessageKey ? (
      <section className='vra-modal-body__content'>
        {spinner}
        <HtmlText messageKey={bodyHtmlMessageKey} messageParams={bodyHtmlMessageParams} />
      </section>
    ) : (
      <section className='vra-modal-body__content'>
        <span>{bodyText}</span>
        {spinner}
      </section>
    );

    const bodyClassString = classNames({
      'vra-modal-body': true,
      'isPending': blocking
    });
    body = (
      <section
        className={bodyClassString}>
        {bodyInner}
      </section>
    );
  }

  const buttons = actions.map(({ action, mode='primary', textKey }, index) => (
    <Button
      className="vra-modal__button"
      key={`message-modal-button-${index}`}
      mode={mode}
      onClick={action}
      testId={`message-modal-button-${index}`}>
      {getMessage(textKey)}
    </Button>
  ));

  footerText = footerText ? (
    <small className='vra-modal__footer__text'>
      {footerText}
    </small>
  ) : null;

  const footer = (buttons || footerText) ? (
    <footer className='vra-modal-footer'>
      {buttons}
      {footerText}
    </footer>
  ) : null;

  return (
    <CrateModal
      className='vra-modal'
      show={true}
      size={size}
      testId='vra-modal'
    >
      <section className={classString}>
        {header}
        {body}
        {footer}
      </section>
    </CrateModal>
  );
};

MessageModal.propTypes = {
  actions: propTypes.array,
  blocking: propTypes.bool,
  bodyHtmlMessageKey: propTypes.string, // I18n message key.
  bodyHtmlMessageParams: propTypes.object, // Params inserted into i18n message.
  bodyText: propTypes.string, // Plain text message to display in body. Use either bodyHtml* or bodyText.
  buttons: propTypes.arrayOf(propTypes.element),
  className: propTypes.string,
  footerText: propTypes.string,
  name: propTypes.string,
  size: propTypes.oneOf(['S', 'M', 'L', 'XL']),
  title: propTypes.string
};

export default MessageModal;
